import React from 'react'
import styles from './Main.module.scss'
import InitialPage from '../../components/initialPage/InitialPage'
import Catalog from '../../components/Catalog/Catalog'
import SliderAdvantages from '../../components/SliderAdvantages/SliderAdvantages'
import AboutMe from '../../components/AboutMe/AboutMe'
import Shops from '../../components/Shops/Shops'
import { arrAdvantages } from '../../utils/data'
import { arrPartner } from '../../utils/data'
import { arrMarcet } from '../../utils/data'


const Main = () => {

    return (
        <section className={styles.main}>
            <InitialPage
            />
            <SliderAdvantages
            arr={arrAdvantages}
            />
            <AboutMe/>
            <SliderAdvantages
            arr={arrMarcet}
            />
            <Catalog/>
            <SliderAdvantages
            arr={arrMarcet}
            />
            <Shops/>
            <SliderAdvantages
            arr={arrPartner}
            />
        </section>
    )
}

export default Main